// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__dCnuw","row":"Layout_row__CRUaT","col":"Layout_col__Jl1KS"};